export const Ethnicities: string[] = [
    "African",
    "Arab",
    "Asian",
    "Baltic",
    "Black/African-American",
    "Caribbean",
    "Caucasian",
    "Central American",
    "East Asian",
    "Eastern European",
    "Hispanic/Latino",
    "Indian",
    "Indigenous Australian",
    "Middle Eastern",
    "Native American",
    "North African",
    "Pacific Islander",
    "Scandinavian",
    "South American",
    "South Asian",
    "Southeast Asian",
    "Sub-Saharan African",
    "Western European",
];